import { render, staticRenderFns } from "./CloudTheatreDetails.vue?vue&type=template&id=c674674a&"
import script from "./CloudTheatreDetails.vue?vue&type=script&lang=ts&"
export * from "./CloudTheatreDetails.vue?vue&type=script&lang=ts&"
import style0 from "./CloudTheatreDetails.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports